/**
 *  Zestaw funkcji do obliczania statystyk
 * 
 */

import statsConfig from '../../config/stats.json';
import { getDailyTimestamp, secsToStr } from '../../tools';

// Zwrace liczbę sekund dla danego dnia in: { p: 234, a: 567, h: 845 ... }
export function calcDailyTime (timesObj) {
  let totalTime = 0;
  for (let prop in timesObj) {
    totalTime += timesObj[prop];
  }
  return totalTime
}

// Zwraca dane za bieżący dzień
export function getDailyData(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return {};
  const today = getDailyTimestamp();
  const times = userState.stats[courseId].times;
  return times[today];
}

// Zwraca poszczególne czasy z okresu tygodnia
export function getWeeklySumData(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return {};
  const newTimes = { ...statsConfig.defaults };
  const week = getDailyTimestamp() - 7 * 60 * 60 * 24;
  const times = userState.stats[courseId].times;
  for (let time in times) {
    if (parseInt(time) > week) {
      const obj = times[time];
      Object.keys(obj).forEach(key => {
        newTimes[key] += obj[key];
      });
    }
  }
  return newTimes;
}

// Zwraca liczbę sekund z bieżącego dnia
export function getDailyTime(userState) {
  return calcDailyTime(getDailyData(userState));
}

// zwraca czas z bieżącego dnia w fromacie H:mm
export function getDailyTimeStr(userState) {
  return secsToStr(getDailyTime(userState), 'h:mm');
}

// Podobnie jak w getDailyTime tyle, że za cały tydzień
export function getWeeklyTime(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return 0;
  const dailySeconds = 60 * 60 * 24;
  const today = getDailyTimestamp();
  const times = userState.stats[courseId].times;
  let weeklyTime = 0;
  for (let i = 0; i < 7; ++i) {
    weeklyTime += calcDailyTime(times[today - dailySeconds * i]);
  }
  return weeklyTime;
}

// zwraca czas z ostatniego tygodnia w fromacie H:mm
export function getWeeklyTimeStr(userState) {
  return secsToStr(getWeeklyTime(userState), 'h:mm');
}

// konwertuje milisekundy na czas
export function getTime(ms) {
  return secsToStr(ms / 1000, 'h:mm');
}

export function clearOutdatedData(userState) {
  const courseId = userState.currentCourseId;
  if (!courseId) return userState;
  const todaysTime = getDailyTimestamp();
  const times = { ...userState.stats[courseId].times };
  const newUserState = { ...userState };
  const week = todaysTime - 7 * 60 * 60 * 24;
  for (let time in times) {
    if (parseInt(time) <= week) delete times[time];
  }
  newUserState.stats[courseId].times = times;
  return newUserState;
}
